// export const handleImage = (image) => {
//   if (image) {
//     return `${process.env.REACT_APP_URL}${image}`;
//   }
//   return "https://picsum.photos/seed/picsum/200/300";
// };

import { REACT_APP_URL } from "config";
import { toast } from "react-toastify";

export const handleImage = (image) => {
    if (image) {
        if (!image.includes("https")) image = `${REACT_APP_URL}/${image}`;
        return image;
    }
    return "";
};

export const cutImageFullPath = (image) => {
    const cutImage = "uploads/" + image?.split("/")?.pop();

    return cutImage;
};

export const handleSearchParamsChange = (search, params) => {
    const url = new URLSearchParams("");
    search = { ...search, ...params };
    Object.entries(search).map(([key, value]) => {
        return url.set(key, value);
    });
    return "?" + url;
};

export const themeSwitcherFunction = () => {
    document.querySelector("body").classList.toggle("dark");

    const currentTheme = document.documentElement.getAttribute("data-theme");
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
};

export const getSettingsBySlug = (settings, slug) => {
    return settings.find((setting) => {
        return setting._id === slug;
    });
};

export const getToday = () => {
    let today = new Date();
    let dd = String(today.getDate());
    let mm = String(today.getMonth() + 1); //January is 0!
    let yyyy = today.getFullYear();

    today = `${yyyy}-${mm}-${dd}`;
    return today;
};

export const getDateOfBirthWithFormat = (date) => {
    let newDateWithFormate = new Date(date);

    let dd = String(newDateWithFormate.getDate()).padStart(2, "0");
    let mm = String(newDateWithFormate.getMonth() + 1).padStart(2, "0");
    let yyyy = newDateWithFormate.getFullYear();

    newDateWithFormate = `${yyyy}-${mm}-${dd}`;
    return newDateWithFormate;
};

export const selctOptionValues = (options, selectedOption) => {
    const option = options?.find((option) => option?.value === selectedOption);

    return option;
};

export const handleSkillsDefaultValues = (options) => {
    return options?.map((option) => {
        return {
            value: option?.id,
            label: option?.name,
        };
    });
};

export const truncate = (str, n) => {
    return str.length > n ? str.slice(0, n - 1) + "..." : str;
};

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
}
export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(
        function () {
            console.log("Async: Copying to clipboard was successful!");
            toast("Copied");
        },
        function (err) {
            console.error("Async: Could not copy text: ", err);
        }
    );
}

export function isImage(url) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

export const getId = (obj) => obj?._id || obj?.id;

export const handleErrMsg = (error) => {
    let errorMessage,
        statusCode = error?.statusCode;

    switch (statusCode) {
        case 400:
            errorMessage = "Bad Request";
            break;
        case 401:
            errorMessage = "Unauthorized";
            break;
        case 403:
            errorMessage = "Forbidden";
            break;
        case 404:
            errorMessage = "Not Found";
            break;
        case 500:
            errorMessage = "Internal Server Error";
            break;
        default:
            errorMessage = error?.errors?.[0]?.msg || "Unknown Error";
            break;
    }

    return errorMessage;
};
